import { VideoApi } from './VideoApi'
import { Subscription } from '../rpc'
import { mockLog } from '../MockDebug'

const TAG = 'Mock Video'

export class MockVideoApi implements VideoApi {
  async requestPiPAsync(input: {
    contentId: string
    videoUrl: string
    positionSeconds: number
    playbackRate?: number
    contentLabel?: string
  }): Promise<{ sessionId: string }> {
    mockLog(TAG, `requestPiPAsync contentId=${input.contentId}`)
    return { sessionId: 'mock-session-id' }
  }

  async readyForPlaybackResumeAsync(input: {
    sessionId: string
  }): Promise<void> {
  }

  async resumeAckAsync(input: { sessionId: string }): Promise<void> {
  }

  onResumeFromNativePlayback(callback: (data: {
    sessionId: string
    positionSeconds: number
    contentId: string
  }) => void): Subscription {
    return {
      unsubscribe: () => {},
    }
  }
}
